<template>
  <b-card>
    <LeaveReasonModal @refetch="fetchList" />
    <RemoveLeaveReasonModal
      :reason="toBeDeletedReason"
      @deleted="fetchList"
    />
    <b-button
      class="mb-1"
      variant="primary"
      @click="$bvModal.show('create-leave-reason-modal')"
    >
      Create New Leave Reason
    </b-button>
    <BaseOverlay
      :show="loading"
    >
      <b-table
        :fields="tableColumns"
        :items="list"
        striped
        hover
        responsive
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(actions)="data">
          <b-button
            v-if="$can('delete', 'teams')"
            variant="flat-danger"
            @click="openDeleteReasonHandler(data.item)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>
      </b-table>
    </BaseOverlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import formatDate from '@/utils/date-format'
import LeaveReasonModal from '../components/LeaveReasonModal.vue'
import RemoveLeaveReasonModal from '../components/RemoveLeaveReasonModal.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BaseOverlay,
    LeaveReasonModal,
    RemoveLeaveReasonModal,
  },
  setup(_, ctx) {
    const tableColumns = [
      {
        label: 'Reason English',
        key: 'reasonEn',
        formatter: (_1, _2, item) => item.reason.en,
      },
      {
        label: 'Reason Arabic',
        key: 'reasonAr',
        formatter: (_1, _2, item) => item.reason.ar,
      },
      {
        key: 'createdAt',
        label: 'created at',
        formatter: val => formatDate(val),
      },
      'actions',
    ]
    const list = ref([])
    const loading = ref(false)

    const fetchList = async () => {
      loading.value = true

      const result = await axiosIns.get('/teams/leave-reasons')
      list.value = result.data.data
      loading.value = false
    }
    fetchList()

    const toBeDeletedReason = ref()
    const openDeleteReasonHandler = reason => {
      toBeDeletedReason.value = reason
      ctx.root.$bvModal.show('remove-leave-reason-modal')
    }

    return {
      loading,
      tableColumns,
      list,
      openDeleteReasonHandler,
      toBeDeletedReason,
      fetchList,
    }
  },
}
</script>

    <style></style>
